module.exports = __webpack_public_path__ + "img/candidates-hvr1.116680e3.jpg";